// Which stations the picker leads with.
//
// A work centre carries a roster — the employees allowed to work there, the
// same relation an employee's `workcenter_ids` reads from the other side. An
// operator choosing a station is almost always choosing one of theirs, so the
// picker opens on those and keeps the rest one tap away. Nothing here decides
// what Odoo will accept: a kiosk operator off a roster is refused by Odoo at
// Start, and a named user is let through everywhere (interpod_mrp_shopfloor).

export interface RosteredStation {
  id: number;
  employeeIds: number[];
}

/** The stations whose roster names this operator. Empty when none does. */
export function rosterStations<T extends RosteredStation>(stations: readonly T[], operatorId: number | null | undefined): T[] {
  if (operatorId == null) return [];
  return stations.filter((s) => s.employeeIds.includes(operatorId));
}

/**
 * Whether the picker should open on the operator's own stations. Only when
 * there is somebody signed in and at least one roster names them: an operator
 * on no roster, or a leader looking at the floor, sees every station.
 */
export function leadWithRoster<T extends RosteredStation>(stations: readonly T[], operatorId: number | null | undefined): boolean {
  return rosterStations(stations, operatorId).length > 0;
}
